<template>
  <winner-item v-bind="itemProps">
    <template #beforeTitle>
      <span class="d-flex align-items-center">
        <flag
          class="flag-rectangular flag-sm mr-2"
          :iso="value.nationality"
          :squared="false"
        />
        <small class="smaller font-weight-bold text-condensed">{{ getIoc(value.nationality) }}</small>
      </span>
    </template>

    <animated-number
      :value="value.distance / 1000"
      :decimals="3"
      :class="['h4 text-uppercase', $textColor]"
      tag="div"
    >
      <template slot-scope="{ value }">
        {{ $formatDistance(value.slice(0, -2)) }}
      </template>
    </animated-number>
  </winner-item>
</template>

<script>
import { mapGetters } from 'vuex'
import getIoc from '@/util/ioc'
import mediaObjectMixin from '@/mixins/mediaObject'
import { icons } from '@/constants/location'
import { athleteTypes as types } from '@/constants/participant'
import WinnerItem from './WinnerItem.vue'

export default {
  name: 'ParticipantWinnerItem',
  icons,
  types,
  components: {
    WinnerItem
  },
  mixins: [mediaObjectMixin],
  props: {
    textColor: {
      type: String,
      default: 'secondary'
    }
  },
  computed: {
    ...mapGetters([
      'locationById'
    ]),
    $textColor() {
      return `text-${this.textColor}`
    },
    location() {
      return this.locationById(this.value.locationId)
    },
    itemProps() {
      const participant = this.value
      const { location } = this

      return {
        key: participant.id,
        title: participant.fullname,
        text: location ? `${location.title}, ${location.ioc}` : '',
        image: participant.avatar,
        url: participant.url
      }
    }
  },
  methods: {
    getIoc
  }
}
</script>
